<template>
  <header class="sticky top-0 z-50 bg-white shadow-sm">
    <!-- Top bar -->
    <div class="bg-brand text-white text-sm py-2 hidden md:block">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center">
        <span>Free delivery on orders over 5,000 Rwf</span>
        <span class="flex items-center gap-1">
          <PhoneIcon class="w-4 h-4" />
          +250 788 288 199
        </span>
      </div>
    </div>

    <!-- Main navbar -->
    <nav class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex items-center justify-between h-16">

        <!-- Logo -->
        <router-link to="/" class="flex items-center gap-2 flex-shrink-0">
          <img src="@/assets/logo-final.png" alt="HomeSweet Bites" class="h-12 w-auto" />
        </router-link>

        <!-- Desktop nav links -->
        <ul class="hidden md:flex items-center gap-4 lg:gap-8 font-medium text-accent">
          <li>
            <router-link
              to="/"
              class="hover:text-brand transition-colors duration-150"
              active-class="text-brand font-semibold"
            >Home</router-link>
          </li>
          <li>
            <router-link
              to="/menu"
              class="hover:text-brand transition-colors duration-150"
              active-class="text-brand font-semibold"
            >Today's Menu</router-link>
          </li>
          <li>
            <router-link
              to="/about"
              class="hover:text-brand transition-colors duration-150"
              active-class="text-brand font-semibold"
            >About Us</router-link>
          </li>
          <li>
            <router-link
              to="/contact"
              class="hover:text-brand transition-colors duration-150"
              active-class="text-brand font-semibold"
            >Contact</router-link>
          </li>
        </ul>

        <!-- Right side: cart + order button -->
        <div class="flex items-center gap-3">
          <!-- Cart icon -->
          <button
            class="relative p-2 rounded-xl hover:bg-cream-200 transition-colors duration-150"
            aria-label="View cart"
            @click="$emit('open-cart')"
          >
            <ShoppingCartIcon class="w-6 h-6 text-accent" />
            <span
              v-if="cartCount > 0"
              class="absolute -top-1 -right-1 bg-brand text-white text-xs font-bold w-4 h-4 sm:w-5 sm:h-5 rounded-full flex items-center justify-center"
            >{{ cartCount }}</span>
          </button>

          <!-- Order now button (desktop) -->
          <router-link to="/menu" class="btn-primary hidden md:inline-flex text-sm px-4 py-2">
            Order Now
          </router-link>

          <!-- Mobile menu toggle -->
          <button
            class="md:hidden p-2 rounded-xl hover:bg-cream-200"
            aria-label="Toggle menu"
            @click="mobileOpen = !mobileOpen"
          >
            <Bars3Icon v-if="!mobileOpen" class="w-6 h-6 text-accent" />
            <XMarkIcon v-else class="w-6 h-6 text-accent" />
          </button>
        </div>
      </div>

      <!-- Mobile dropdown menu -->
      <transition
        enter-active-class="transition duration-150 ease-out"
        enter-from-class="opacity-0 -translate-y-2"
        enter-to-class="opacity-100 translate-y-0"
        leave-active-class="transition duration-100 ease-in"
        leave-from-class="opacity-100 translate-y-0"
        leave-to-class="opacity-0 -translate-y-2"
      >
        <div v-if="mobileOpen" class="md:hidden pb-4 border-t border-cream-200 pt-3">
          <ul class="flex flex-col gap-1 font-medium text-accent">
            <li v-for="link in navLinks" :key="link.to">
              <router-link
                :to="link.to"
                class="block px-3 py-2 rounded-xl hover:bg-cream-200 hover:text-brand transition-colors"
                active-class="bg-brand-100 text-brand font-semibold"
                @click="mobileOpen = false"
              >{{ link.label }}</router-link>
            </li>
          </ul>
          <router-link to="/menu" class="btn-primary w-full mt-3 text-sm" @click="mobileOpen = false">
            Order Now
          </router-link>
        </div>
      </transition>
    </nav>
  </header>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { ShoppingCartIcon, Bars3Icon, XMarkIcon, PhoneIcon } from '@heroicons/vue/24/outline'

export default defineComponent({
  name: 'AppNavbar',
  components: { ShoppingCartIcon, Bars3Icon, XMarkIcon, PhoneIcon },
  props: {
    cartCount: {
      type: Number,
      default: 0
    }
  },
  emits: ['open-cart'],
  setup () {
    const mobileOpen = ref(false)
    const navLinks = [
      { to: '/', label: 'Home' },
      { to: '/menu', label: "Today's Menu" },
      { to: '/about', label: 'About Us' },
      { to: '/contact', label: 'Contact' }
    ]
    return { mobileOpen, navLinks }
  }
})
</script>
